/**
 * `/poste/appairage` — enrolling the lobby machine as a gate device.
 *
 * Same handshake the phone uses (`gateDevice.requestPairing` → display the
 * user code → poll `pollPairing` until staff approve it in the console), and
 * deliberately the same handshake rather than a web-specific shortcut: the
 * approval step is where a human decides that this particular machine, in this
 * particular lobby, may act for a gate. A self-service web login would skip
 * exactly that.
 *
 * The token is issued on the first poll after approval and is issued once, so
 * it is written to storage before anything else happens.
 */
import { useCallback } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { PairingScreen } from "~/components/station/pairing-screen";
import { setDeviceToken } from "~/lib/station/device-token";

export const Route = createFileRoute("/poste/appairage")({
  component: StationPairingPage,
});

function StationPairingPage() {
  const navigate = useNavigate();
  const onToken = useCallback(
    async (token: string) => {
      setDeviceToken(token);
      await navigate({ to: "/poste/acces", replace: true });
    },
    [navigate],
  );
  return (
    <PairingScreen
      scope="poste"
      title={
        <>
          Enregistrez
          <br />
          ce poste.
        </>
      }
      lead="Saisissez ce code dans la console Gately pour lier ce poste à un portail."
      onToken={onToken}
    />
  );
}
